export default __webpack_public_path__ + "static/deals-header-d97e7ddba2fe1a1df93b3a102d9f0a37.png";